
export default {
    getPdfConfigurations: (state) => state.pdfConfigurations,
}